// v-copy.js
import { message } from 'ant-design-vue';
export default {
    mounted(el, binding) {
      el.style.cursor = 'pointer';

      // 初次挂载时添加事件监听器
      el._handleClick = () => {
        const textToCopy = binding.value; // 获取当前绑定的值
        if (textToCopy) {
          copyTextToClipboard(textToCopy);
        } else {
          console.warn('v-copy: 没有提供需要复制的内容');
        }
      };
  
      // 绑定点击事件
      el.addEventListener('click', el._handleClick);
    },
    updated(el, binding) {
      // 在元素更新时确保能够获取最新的绑定值
      // 每次绑定的值变化时，先移除旧的点击事件，再重新绑定新事件
      el.removeEventListener('click', el._handleClick);

      // 更新点击事件监听器以获取最新的值
      el._handleClick = () => {
        const textToCopy = binding.value; // 获取更新后的值
        if (textToCopy) {
          copyTextToClipboard(textToCopy);
        } else {
          console.warn('v-copy: 没有提供需要复制的内容');
        }
      };

      // 重新绑定点击事件
      el.addEventListener('click', el._handleClick);
      },
    beforeUnmount(el) {
      el.removeEventListener('click', () => {});
    }
  };
  
  // 复制到剪贴板的功能
  function copyTextToClipboard(text) {
    // 创建一个临时的文本区域元素，用于拷贝
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select(); // 选择文本
    document.execCommand('copy'); // 执行拷贝命令
    document.body.removeChild(textarea); // 移除临时的文本区域
    console.log('已复制:', text); // 可选：控制台提示已复制的文本
    message.info('复制成功!');
  }
  